import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { EntityTypeEnum } from '@api/ringil-api.v2';

interface ComponentProps {
  value: EntityTypeEnum;
  onChange: (value: EntityTypeEnum) => void;
  /** restrict the offered types (e.g. by the company's modules); defaults to every folder entity type */
  options?: EntityTypeEnum[];
}

// RD-2977: folders exist for expeditions, reservations (TIMESLOT) and supplier notifications
const FOLDER_ENTITY_TYPES = [EntityTypeEnum.EXPEDITION, EntityTypeEnum.TIMESLOT, EntityTypeEnum.SUPPLIER_NOTIFICATION];

const InputEntityType: React.FC<ComponentProps> = ({ onChange, value, options }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      <Dropdown
        value={value}
        onChange={e => onChange(e.value)}
        options={(options ?? FOLDER_ENTITY_TYPES).map(t => ({ value: t, label: tr(`EntityType.${t}`, t) }))}
        placeholder={tr('InputEntityType.selectEntityType', 'Select Entity Type')}
      />
    </>
  );
};

export default InputEntityType;
